import { COLOR_PALETTE_LIST } from '@/dashboard/features/widgets/common/constants/color.defines';
import { defineStore } from 'pinia';

export const useSeriesColorListStore = defineStore('seriesColorList', () => {
  const seriesColorList: string[] = [];

  const setSeriesColorList = () => {
    const GRAY_COLOR_COUNT = COLOR_PALETTE_LIST.WARM_GRAY.length;
    const TOTAL_COLOR_TYPE_COUNT = Object.keys(COLOR_PALETTE_LIST).length;
    const GRAY_TYPE_COUNT = 2; // warm gray, cool gray
    Object.values(COLOR_PALETTE_LIST).forEach((colors, groupIndex) => {
      colors.forEach((color, idx) => {
        const colorTypeCount =
          idx < GRAY_COLOR_COUNT
            ? TOTAL_COLOR_TYPE_COUNT
            : TOTAL_COLOR_TYPE_COUNT - GRAY_TYPE_COUNT;

        const reverseIdx = colors.length - idx - 1;
        const baseIndex =
          idx < GRAY_COLOR_COUNT
            ? idx * colorTypeCount
            : (idx - GRAY_COLOR_COUNT) * colorTypeCount + TOTAL_COLOR_TYPE_COUNT * GRAY_COLOR_COUNT;
        const index = baseIndex + groupIndex;

        seriesColorList[index] = colors[reverseIdx]?.background ?? '';
      });
    });
  };

  const getDefaultSeriesColors = () => {
    if (seriesColorList.length === 0) {
      setSeriesColorList();
    }
    return seriesColorList;
  };

  const getDefaultSeriesColor = (idx: number, beforeColor?: string) => {
    if (!seriesColorList) {
      return '';
    }
    if (beforeColor) {
      const colorIdx = seriesColorList.findIndex((color) => color === beforeColor);
      return colorIdx > -1
        ? seriesColorList[(colorIdx + 1) % seriesColorList.length]
        : seriesColorList[idx % seriesColorList.length];
    }
    return seriesColorList[idx % seriesColorList.length];
  };

  return {
    getDefaultSeriesColors,
    getDefaultSeriesColor,
  };
});
